import Types from "./Types";

export const getPracticeUsersRequest = (page, name) => ({
  type: Types.GET_PRACTICE_USERS_REQUEST,
  payload: page,
  name,
});

export const getPracticeUsersSuccess = (data) => ({
  type: Types.GET_PRACTICE_USERS_SUCCESS,
  payload: data,
});

export const getPracticeUsersFail = () => ({
  type: Types.GET_PRACTICE_USERS_FAIL,
});

export const getPracticeSubjectsRequest = () => ({
  type: Types.GET_PRACTICE_SUBJECTS_REQUEST,
});

export const getPracticeSubjectsSuccess = (data) => ({
  type: Types.GET_PRACTICE_SUBJECTS_SUCCESS,
  payload: data,
});

export const getPracticeSubjectsFail = () => ({
  type: Types.GET_PRACTICE_SUBJECTS_FAIL,
});

export const getActiveSubscriptionsRequest = (subjectId) => ({
  type: Types.GET_ACTIVE_SUBSCRIPTIONS_REQUEST,
  payload: subjectId,
});

export const getActiveSubscriptionsSuccess = (data) => ({
  type: Types.GET_ACTIVE_SUBSCRIPTIONS_SUCCESS,
  payload: data,
});

export const getActiveSubscriptionsFail = () => ({
  type: Types.GET_ACTIVE_SUBSCRIPTIONS_FAIL,
});

export const createPracticeSubscriptionRequest = (payload, action) => ({
  type: Types.CREATE_PRACTICE_SUBSCRIPTION_REQUEST,
  payload,
  action,
});

export const createPracticeSubscriptionSuccess = (data) => ({
  type: Types.CREATE_PRACTICE_SUBSCRIPTION_SUCCESS,
  payload: data,
});

export const createPracticeSubscriptionFail = () => ({
  type: Types.CREATE_PRACTICE_SUBSCRIPTION_FAIL,
});

export const practiceUsersLoading = (isLoading) => ({
  type: Types.PRACTICE_USERS_LOADING,
  payload: isLoading,
});

export const practiceSubjectsLoading = (isLoading) => ({
  type: Types.PRACTICE_SUBJECTS_LOADING,
  payload: isLoading,
});

export const activeSubscriptionsLoading = (isLoading) => ({
  type: Types.ACTIVE_SUBSCRIPTIONS_LOADING,
  payload: isLoading,
});

export const createSubscriptionLoading = (isLoading) => ({
  type: Types.CREATE_SUBSCRIPTION_LOADING,
  payload: isLoading,
});

export const sendBulkCustomMessageToPhonesRequest = (payload, action) => ({
  type: Types.SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_REQUEST,
  payload,
  action,
});

export const sendBulkCustomMessageToPhonesSuccess = (data) => ({
  type: Types.SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_SUCCESS,
  payload: data,
});

export const sendBulkCustomMessageToPhonesFail = () => ({
  type: Types.SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_FAIL,
});

export const sendBulkMessageLoading = (isLoading) => ({
  type: Types.SEND_BULK_MESSAGE_LOADING,
  payload: isLoading,
});
